import Model, { attr, belongsTo, hasMany } from '@ember-data/model'

export default class JuryMemberModel extends Model 
{
	@attr firstName;
	@attr lastName;
	@attr role;
	@attr country;
	@attr id1;
	@attr id2;
	@attr id3;
	
	@belongsTo('event', {inverse: 'juryMembers', async: true}) EventId;
	@belongsTo('class-group', {inverse: 'juryMembers', async: true}) ClassGroupId;
}